import { PageCrumbs } from '@platform/engine/list/header/PageCrumbs';
import type { ISettingsRecordsPageProps } from './ISettingsRecordsPageProps';
import { SettingsModuleHead } from './SettingsModuleHead';
import { SettingsRecords } from './SettingsRecords';

/**
 * «Записи й форми» модуля (прототип v4 page==='cust-module'): з меню модуля (inMod) — на маршруті модуля, з «Налаштування › Встановлені
 * модулі» — у розділі «Налаштування» (CustomizeModulePage), на рівні «Глобально» — глобальне визначення модуля. Смуга крихт, далі колонка,
 * що прокручується разом із шапкою (24px 32px 48px, проміжок 18px): повернення контексту («← Модуль» / «← Модулі»), назва з плиткою, опис,
 * картки «Записи» й «Форми», «Подання». Дочірня таблиця (`rt`, окремий модуль прототипу: «Видатки») — сторінка цієї таблиці.
 */
export function SettingsRecordsPage({ ws, module, rt, focus, crumbs, links, global = false }: ISettingsRecordsPageProps) {
  return (
    <div className="lv-page">
      <PageCrumbs items={crumbs} />
      <div className="st-bp st-rpage">
        <SettingsModuleHead ws={ws} module={module} rt={rt} links={links} global={global} />
        <SettingsRecords ws={ws} module={module} rt={rt} focus={focus} links={links} global={global} />
      </div>
    </div>
  );
}
